document.addEventListener('DOMContentLoaded', function () {

    if (typeof jQuery !== 'undefined') {

        jQuery('#heroSlider').owlCarousel({
            loop: true,
            margin: 0,
            dots: false,
            nav: false,
            mouseDrag: false,
            autoplay: true,
            autoplayTimeout: 7000,
            smartSpeed: 3000,
            animateOut: 'fadeOut',
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            },
            rtl: document.documentElement.dir === 'rtl'            
        });

        $('#heroSliderMobile').owlCarousel({
    loop:true,
    margin:0,
    dots:false,
    nav:false,
    mouseDrag:false,
    // autoplay:true,
    autoplay: 7000,
    smartSpeed: 3000,
    // slideSpeed: 5000,
    animateOut: 'fadeOut',
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    },
    rtl: document.documentElement.dir === 'rtl'
});




    }

});